import { render, staticRenderFns } from "./DataReport.vue?vue&type=template&id=4b8b6f99&scoped=true&"
import script from "./DataReport.vue?vue&type=script&lang=js&"
export * from "./DataReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b6f99",
  null
  
)

export default component.exports